import { forwardRef, ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Fade,
  Grid,
  Divider,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { useStyles } from './dialog-saurus-styles';
import { useThemeQueries } from '../../../../theme';
import { CircularLoading } from '../../utils';
import { CloseIcon } from '../../icons/close-icon';

export interface DialogSaurusProps {
  aberto?: boolean;
  children?: ReactNode;
  icone?: ReactNode;
  carregando?: boolean;
  titulo?: string;
  colorTitulo?: string;
  centralizarTitulo?: boolean;
  tamanho?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  zIndex?: string;
  isButtonTitleClose?: boolean;
  endAdornment?: JSX.Element;
  fullScreen?: boolean;
  bottomArea?: ReactNode;
  handleClickClose?: () => void;
}
const Transition = forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Fade timeout={500} ref={ref} {...props} />;
});

export const DialogSaurus = ({
  aberto,
  children,
  icone,
  carregando,
  centralizarTitulo,
  colorTitulo,
  titulo,
  tamanho,
  zIndex,
  isButtonTitleClose,
  endAdornment,
  fullScreen,
  bottomArea,
  handleClickClose,
}: DialogSaurusProps) => {
  const classes = useStyles();
  const {theme} = useThemeQueries();
  return (
    <Dialog
      maxWidth={tamanho || 'lg'}
      open={aberto || false}
      fullWidth
      disableScrollLock
      keepMounted
      disableEscapeKeyDown
      TransitionComponent={Transition}
      fullScreen={fullScreen}
      ref={(el: any) => {
        if (el && (zIndex || '').length > 0) {
          el.style.setProperty('z-index', zIndex, 'important');
        }
      }}
    >
      <DialogTitle disableTypography>
        {isButtonTitleClose ? (
          <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">
              <strong style={{ color: colorTitulo ? colorTitulo : '#7A7A7A' }}>
                {titulo}
              </strong>
            </Typography>
            <Grid onClick={handleClickClose} className={classes.fecharButton}>
              <CloseIcon tipo="INPUT" />
            </Grid>
          </Grid>
        ) : (
          <Grid
            style={{
              display: 'flex',
              justifyContent: centralizarTitulo ? 'center' : 'space-between',
              alignItems: 'center',
            }}
          >
            {icone ? icone : null}
            <Typography variant="h6">
              <strong style={{ color: colorTitulo ? colorTitulo : '#7A7A7A' }}>
                {titulo}
              </strong>
            </Typography>
            {endAdornment || <></>}
          </Grid>
        )}
        <Divider style={{background: theme.palette.primary.main, height: '2px'}}/>
      </DialogTitle>
      <DialogContent style={
        fullScreen ? {
          padding: '1rem'
        } : {}
      }>
        {carregando ? <CircularLoading tipo="FULLSIZED" /> : children}
      </DialogContent>
      {bottomArea && <div>
        {bottomArea}
      </div>}
    </Dialog>
  );
};
